import React from 'react';
import PropTypes from 'prop-types';
import { StyledTabPanel } from './StyledTabPanel';
function TabPanel(_ref) {
  var children = _ref.children,
    index = _ref.index,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(StyledTabPanel, {
    index: index,
    value: value
  }, children);
}
TabPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component.
   */
  children: PropTypes.node.isRequired,
  /**
   * Tab content number
   */
  index: PropTypes.any.isRequired,
  /**
   * The value of the corresponding Tab. Must use the
   * `index` of the Tab when no value was passed to Tab.
   */
  value: PropTypes.any.isRequired
} : {};
export default TabPanel;